import gleam/list
import gleam/option.{type Option, None, Some}
import homepage/effect/timer
import homepage/fractal.{type Fractal}
import homepage/info
import lustre
import lustre/attribute as a
import lustre/effect.{type Effect}
import lustre/element.{type Element}
import lustre/element/html as h
import lustre/event as e

const tick_time = 5000

pub opaque type Model {
  Model(fractal: Fractal, timer: Option(Int))
}

pub opaque type Msg {
  Tick
  Click
  AddTimer(id: Int)
}

pub fn main() -> Nil {
  let app = lustre.application(init, update, view)
  let assert Ok(_) = lustre.start(app, "#container", Nil)

  Nil
}

fn restart_timer(timer: Option(Int)) -> Effect(Msg) {
  timer.restart(timer, tick_time, AddTimer, Tick)
}

pub fn init(_flags) -> #(Model, Effect(Msg)) {
  #(Model(fractal.new(), None), restart_timer(None))
}

pub fn update(model: Model, msg: Msg) -> #(Model, Effect(Msg)) {
  case msg {
    Tick -> #(
      Model(..model, fractal: fractal.next_iteration(model.fractal)),
      effect.none(),
    )
    Click -> #(
      Model(timer: None, fractal: fractal.next_iteration(model.fractal)),
      restart_timer(model.timer),
    )
    AddTimer(id) -> #(Model(..model, timer: Some(id)), effect.none())
  }
}

pub fn view(model: Model) -> Element(Msg) {
  h.div([a.class("content")], [
    h.div([a.id("fractal"), e.on_click(Click)], [
      h.svg(
        [
          a.attribute("width", "750"),
          a.attribute("height", "1000"),
          a.attribute("viewBox", "0 0 750 1000"),
        ],
        model.fractal
          |> fractal.view
          |> list.append(info.view()),
      ),
    ]),
  ])
}
